import { isInsideMobileWebView } from "@/utils/mobileBridgeAuth";

export function downloadFile(blob: Blob, filename: string) {
  const fileURL = URL.createObjectURL(blob);
  const downloadLink = document.createElement("a");
  downloadLink.href = fileURL;
  downloadLink.download = filename;
  downloadLink.click();
  URL.revokeObjectURL(fileURL);
}

/**
 * Download a file from a (cross-origin, signed) URL, after an async lookup has
 * already consumed the click's user activation.
 *
 * - Inside the mobile app, hands the URL to the native side, which downloads
 *   it and opens the share sheet (the WebView has no downloads UI).
 * - On touch devices, navigates the current tab: mobile Safari blocks a
 *   new-tab link opened outside a user gesture, but not a navigation.
 * - Elsewhere, opens it in a new tab.
 */
export function downloadFromUrl(url: string, filename: string, contentType: string) {
  const nativeDownload = window.__corcaMobile?.downloadFile;
  if (nativeDownload) {
    nativeDownload(url, filename, contentType);
    return;
  }

  if (isInsideMobileWebView() || window.matchMedia("(pointer: coarse)").matches) {
    window.location.assign(url);
    return;
  }

  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.target = "_blank";
  link.rel = "noopener noreferrer";
  link.click();
}
